import { useEffect } from "react";

const STORAGE_KEY = "ftc-tz-captured-v1";

export function useTimezoneCapture(): void {
  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    fetch("/api/users/me/timezone", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ timezone: tz }),
    }).then(r => {
      if (r.ok) localStorage.setItem(STORAGE_KEY, tz);
    }).catch(() => {});
  }, []);
}
